import { useState } from 'react';
import { ImageThumbnail, ImageThumbnailContainer } from 'pages/Representatives/components/ImageThumbnail';
import { IRepresentativeSingleProfileMedia } from 'shared/interfaces/IRepresentativesEditProfile';
import { useImageLoader } from 'pages/Representatives/features/AddRepresentatives/hooks/useImageLoader';
import { EditProfileCustomSkeleton, EditProfileDragContainer, EditProfileNumberBox } from '../../../EditProfile.styles';
import { HideIcon, UserIcon, Move, PencilIcon } from '@room-match/shared-ui-components';

type EditProfileMediaDocumentsImageItemProps = {
  attached_image: IRepresentativeSingleProfileMedia;
  index: number;
};

export const EditProfileMediaDocumentsImageItem = ({
  attached_image,
  index,
}: EditProfileMediaDocumentsImageItemProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const avatar =
    attached_image?.medium?.modified_attachment_url ||
    attached_image?.medium?.attachment_url ||
    attached_image?.medium?.cropped_attachment_url ||
    '';

  const { imgRef, loading } = useImageLoader(avatar);
  return (
    <ImageThumbnailContainer
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ transform: isHovered ? 'scale(1.1)' : 'scale(1)' }}
    >
      {loading ? <EditProfileCustomSkeleton variant="rect" width={'100%'} height={'100%'} /> : null}
      <EditProfileNumberBox>
        {attached_image?.primary ? <UserIcon fill="white" /> : isHovered ? <HideIcon /> : index}
      </EditProfileNumberBox>
      {!attached_image?.primary && isHovered ? (
        <EditProfileDragContainer>
          <Move viewBox="0 0 16 16" />
        </EditProfileDragContainer>
      ) : null}
      {isHovered ? (
        <EditProfileNumberBox style={{ inset: 'unset', bottom: 5, left: 5 }}>
          <PencilIcon htmlColor="white" />
        </EditProfileNumberBox>
      ) : null}
      <ImageThumbnail ref={imgRef} style={{ display: loading ? 'none' : 'block' }} src={avatar} />
    </ImageThumbnailContainer>
  );
};
